import { Flex, font } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { SectionParagraph, SectionTitle } from '../shared/Content';
import { POSTS } from './postData';

const Title = styled(SectionTitle)`
  text-align: left;
  padding: 0;
  text-wrap: pretty;
`;

const Summary = styled(SectionParagraph)`
  text-align: left;
`;

const Link = styled.a`
  ${font('main', { fontSize: '1.6rem', fontWeight: 'bold' })};
`;

export const Posts = () => {
  return (
    <Flex flexDirection="column" gap="50px" width="100%" maxWidth="900px" mx="auto" mt="40px">
      {POSTS.map(post => (
        <Flex key={post.title} flexDirection="column" gap="16px">
          <Title>{post.title}</Title>
          <Summary>{post.summary}</Summary>
          <Link href={post.url}>Read more...</Link>
        </Flex>
      ))}
    </Flex>
  );
};
